import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  listActiveSessions,
  revokeOtherSessions,
  revokeSession,
  type ListSessionsResponse,
} from '../api/sessions.client.js';

/**
 * Ключ без workspaceId: сессии принадлежат пользователю, а не рабочему
 * пространству, и при переключении workspace список не меняется.
 */
const SESSIONS_KEY = ['auth', 'sessions'] as const;

export function useActiveSessions() {
  return useQuery<ListSessionsResponse>({
    queryKey: SESSIONS_KEY,
    queryFn: listActiveSessions,
  });
}

function useInvalidateSessions(): () => Promise<void> {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: SESSIONS_KEY });
}

export function useRevokeSessionMutation() {
  const invalidate = useInvalidateSessions();

  return useMutation<void, Error, string>({
    mutationFn: (sessionId) => revokeSession(sessionId),
    onSuccess: () => invalidate(),
  });
}

export function useRevokeOtherSessionsMutation() {
  const invalidate = useInvalidateSessions();

  return useMutation<{ count: number }, Error, void>({
    mutationFn: () => revokeOtherSessions(),
    onSuccess: () => invalidate(),
  });
}
